import React from 'react'



export const options = {
          method: 'GET',
          headers: {
            accept: 'application/json',
            Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIwMWVlNzJhYzljY2MzMDBjYzlmZDJmOGE5OGJiODY4MiIsInN1YiI6IjY0NjFlMTcwZGJiYjQyMDEzNjM3YTJhYyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.g2Cx6IQWjU6NRC0arZFvgxjZF3hn-L4ptTu57hiKF8w'
          }
};